import * as yup from 'yup';
import { alphabetRegix, alphaNumericRegix, alphaNumericSpecialCharacterRegix, numericRegix, phoneRegex } from '../utils/functions';
import { isValidPhoneNumber } from 'libphonenumber-js';
export const contact_info_validation_schema = yup.object().shape({
  contactPersonName: yup.string().required('contact_person_name_is_required').matches(alphabetRegix, 'must_be_alphabetic'),
  jobTitle: yup.string().required('job_title_is_required').matches(alphabetRegix, 'must_be_alphabetic'),
  workPhoneNumber: yup
  .string()
  .nullable()
  .notRequired()
  .test(
    'valid-phone',
    'invalid_phone_no',
    function (value) {
      if (!value || value.trim() === '') {
        return true; // ✅ Empty allowed
      }
      return isValidPhoneNumber(value);
    }
  ),
  mobileNumber: yup
    .string()
    .required('mobile_no_is_required')
    .test(
      'is-valid-phone',
      'invalid_phone_no',
      (value) => {
        if (!value) return false;
        return isValidPhoneNumber(value);
      }
    ),
  workEmail: yup.string().email('invalid_email').required('work_email_is_required'),
  preferredLanguageForCorrespondence: yup.string().required('preferred_language_is_required'),
  contactPreferenceEmail: yup.array().min(1, 'preferred_correspondence_is_required').required('preferred_correspondence_is_required'),
  countryNonKsa: yup.string().required('country_is_required'),
  buildingNumberKsa: yup
    .string()
    .required('building_number_is_required')
    .matches(/^[0-9-]+$/, 'invalid_building_no'),
  streetNameKsa: yup.string().required('street_name_is_required').matches(alphaNumericRegix, 'must_be_alphanumeric'),
  districtKsa: yup.string().required('district_is_required').matches(alphaNumericSpecialCharacterRegix, 'must_be_alphanumeric'),
  cityKsa: yup.string().required('city_is_required'),
  postalCodeKsa: yup
    .string()
    .required('zip_code_is_required')
    .matches(/^[0-9-]+$/, 'invalid_zip_code'),
  additionalNumberKsa: yup.string().required('additional_phone_no_is_required'),
  unitNoKsa: yup.string().required('unit_number_is_required').matches(numericRegix, 'unit_no_must_be_numeric'),
  anyOtherFinancialInfo: yup.string(),
});
